import { AppError } from '@core/api';

export enum TreeNodeTypes {
  FOLDER,
  LAYER,
  PARCEL,
  GROUP,
  FEATURE,
}

export interface TreeNode {
  id: string | number;
  jobCode?: string;
  path: string;
  type: TreeNodeTypes;
  name: string;
  icon?: string;
  visible: boolean;
  readonly?: boolean;
  survey?: boolean;
  surveyLocked?: boolean;
  published?: boolean;
  content?: TreeNode[];
  layer?: string;
  parcel?: string;
  error?: AppError;
  editing?: {
    firstName?: string;
    lastName?: string;
  };
  owner?: string;
}

export interface TreeSelection {
  folders?: (string | number)[];
  layers?: string[];
  parcels?: string[];
  features?: (string | number)[];
}

export type FolderActionType = 'delete' | 'publish' | 'unpublish' | 'rename' | 'show' | 'hide' | 'lock' | 'unlock';

export interface FolderAction {
  node: TreeNode;
  type: FolderActionType;
}

export type LayerActionType =
  | 'publish'
  | 'unpublish'
  | 'rename'
  | 'show'
  | 'hide'
  | 'lock'
  | 'unlock'
  | 'select_all'
  | 'plan_details'
  | 'duplicate'
  | 'archive'
  | 'zoom_to'
  | 'export'
  | 'table_view'
  | 'toolbox'
  | 'delete'
  | 'edit_job_code';

export interface LayerAction {
  node: TreeNode;
  type: LayerActionType;
}

export type ParcelActionType = 'rename' | 'show' | 'hide' | 'zoom';

export interface ParcelAction {
  node: TreeNode;
  type: ParcelActionType;
}

export type FeatureActionType = 'show' | 'hide' | 'select' | 'zoom' | 'move' | 'delete';

export interface FeatureAction {
  node: TreeNode;
  type: FeatureActionType;
}
